import { defineMessages } from 'react-intl-next';

export const messages: {
    noImageLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	noImageLabel: {
		id: 'company-hub.company-hub-common.unsplash-search.default-image-picker.no-image',
		defaultMessage: 'No image',
		description: 'Alt label for default unsplash pick with no image',
	},
});
